import { Component } from '@angular/core';
import { GetNortonProductsAttributes } from '../store/actions/norton.actions';
import * as ProductsActions from '../../store/actions/products.actions';
import { TranslationService } from '@proximus/ng-common';
import { ApplicationState } from 'src/app/store/reducers';
import { Store } from '@ngrx/store';


@Component({
  selector: 'mprd-norton-family-subscription',
  templateUrl: './norton-family-subscription.component.html',
})
export class NortonFamilySubscriptionComponent {
  nortonFamilyMpcUuid: string;
  constructor(private readonly store: Store<ApplicationState>,
    private readonly translationService: TranslationService) {
  }

  ngOnInit() {
    this.nortonFamilyMpcUuid = this.translationService.getTranslatedValueFor('norton.subscription.nortonFamilyMpcUuid');
    this.store.dispatch(new ProductsActions.GetProducts());
    this.store.dispatch(
      new GetNortonProductsAttributes({
        mpcUuids: [this.nortonFamilyMpcUuid],
      }),
    );
  }
}
